import { KeyboardEvent, useEffect } from 'react';

import { isWeb } from '@/utils/constants-platform-specific';

/**
 * Global Cmd+K (Ctrl+K on non-mac) shortcut for opening the search, active while the calling
 * component is mounted. Web only, no-op on native.
 */
export const useSearchHotkey = (onTrigger?: () => void) => {
    useEffect(() => {
        if (!isWeb || !onTrigger) {
            return;
        }

        const handleKeyDown = (event: KeyboardEvent) => {
            if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
                event.preventDefault();
                onTrigger();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [onTrigger]);
};
